(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('GeonameLocalizationDetailController', GeonameLocalizationDetailController);

    GeonameLocalizationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'GeonameLocalization'];

    function GeonameLocalizationDetailController($scope, $rootScope, $stateParams, previousState, entity, GeonameLocalization) {
        var vm = this;

        vm.geonameLocalization = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('publicGatewayApp:geonameLocalizationUpdate', function(event, result) {
            vm.geonameLocalization = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
